import React, { useEffect, useState } from 'react';
import { InputTextField, Title } from '@icarros/ids-react';
import { useAdContext } from '../../../store/contexts/ad';
import { OpenEditTitleWrapper, OpenEditWrapper } from './style';
import { useAd } from '../../../store/hooks/useAd';
import { Loading } from '../../../components/Loading';
import { SaveFormContent } from './SaveFormContent';
import { useQueryClient } from '@tanstack/react-query';
import { GET_CONFIGURATIONS } from '../../../queries';
import { ConfigurationClient } from '../../../services/Configurations.service';
import isMobile from '../../../utils/is-mobile';
import { formatNumber } from '../../../utils/formatters';

export function KmForm(): JSX.Element {
  const { setCurrentContent, loading, initialLoading } = useAd();
  const { currentAd, setValueIsDifferentFromCurrent } = useAdContext();
  const { km = 0 } = currentAd?.veiculo || {};
  const [kmValue, setKmValue] = useState<number | undefined>(undefined);
  const client = useQueryClient();
  const configQuery = client.getQueryData<ConfigurationClient>([GET_CONFIGURATIONS]);
  const configData = isMobile() ? configQuery?.webmobile : configQuery?.web;
  const kmBetweenOneAndCurrentMaxKm =
    kmValue && configData ? kmValue >= 1 && kmValue <= configData?.maxValueKm : false;

  useEffect(() => {
    setKmValue(km);
  }, [km]);

  useEffect(() => {
    setValueIsDifferentFromCurrent(kmValue !== km && kmBetweenOneAndCurrentMaxKm);
  }, [kmValue, km, setValueIsDifferentFromCurrent, kmBetweenOneAndCurrentMaxKm]);

  return (
    <OpenEditWrapper>
      <OpenEditTitleWrapper>
        <Title size="overline">editar dados do veículo</Title>
        <Title variant="default" contrast="light">
          qual é a quilometragem do seu carro?
        </Title>
        <InputTextField
          initialValue={String(kmValue)}
          inputLabel="quilometragem (km)"
          types="number"
          onChange={event => {
            let { value } = event.target;
            value = value.replace(/\D/gm, '');
            return setKmValue(value.length ? Number(value) : undefined);
          }}
          value={kmValue ? String(kmValue) : undefined}
          isError={!kmBetweenOneAndCurrentMaxKm}
          helperText={
            !kmBetweenOneAndCurrentMaxKm &&
            `o valor deve estar entre 1 km e ${formatNumber(configData?.maxValueKm)}`
          }
        />
      </OpenEditTitleWrapper>
      {(initialLoading || loading) && <Loading backgroundOnly={loading} />}

      {!(initialLoading && kmValue === km) && (
        <SaveFormContent
          loading={loading}
          isDisabled={kmValue === km || !kmBetweenOneAndCurrentMaxKm}
          handleClick={() =>
            setCurrentContent({
              veiculo: {
                km: kmValue
              }
            })
          }
        />
      )}
    </OpenEditWrapper>
  );
}
